import { render, staticRenderFns } from "./AssetBox.vue?vue&type=template&id=5f5b9a9a"
import script from "./AssetBox.js?vue&type=script&lang=js&external"
export * from "./AssetBox.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports